import React, { useContext, useEffect, useState } from "react";
import { Button, Col, DatePicker, Drawer, Form, Input, Row, Upload, Select, Space, message, } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import dayjs from "dayjs";
import { DriverContext } from ".";
import { ApiConfig } from "../../services/ApiConfigs";
import { ApiServices, uploadDocument } from "../../services/apiServices";
import { useSelector } from "react-redux";

const { Option } = Select;

const AddDrivers = () => {
    const { addModalOpen, setAddModalOpen, getUsers, driver, wareHouseData, selectedDriver } = useContext(DriverContext);
    const [form] = Form.useForm();

    const [photoList, setPhotoList] = useState([]);
    const [drivingLicenseList, setDrivingLicenseList] = useState([]);
    const [identityDocuments, setIdentityDocuments] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState([]);


    const userDetail = useSelector((res) => res.UserData.userData.user)

    const keepLocalFiles = (fileList) =>
        (Array.isArray(fileList) ? fileList : []).map((f) => ({
            ...f,
            // Prevent Ant Upload from showing red/error state when no `action` is used.
            status: "done",
        }));

    // useEffect(() => {
    //     setPhotoList(driver.photoData ? [{ uid: driver.photoData.id, name: driver.photoData.name, url: `${ApiConfig.URL}/${driver.photoData.name}` }] : []);
    //     setIdentityDocuments(driver.identityDocumentsData ? [{ uid: driver.identityDocumentsData.id, name: driver.identityDocumentsData.name, url: `${ApiConfig.URL}/${driver.identityDocumentsData.name}` }] : []);
    //     setDrivingLicenseList(driver.documentsData ? [{ uid: driver.documentsData.id, name: driver.documentsData.name, url: `${ApiConfig.URL}/${driver.documentsData.name}` }] : []);
    // }, [driver])


    useEffect(() => {
        if (!driver) return;
        // Phase 10: warehouses from DriverWarehouses (driver.warehouses) or legacy driver.warehouse
        let warehouseIds = [];
        if (driver.warehouses && Array.isArray(driver.warehouses)) {
            warehouseIds = driver.warehouses.map(w => (typeof w === 'object' ? w.id : w));
        } else if (driver.warehouse) {
            warehouseIds = String(driver.warehouse).replace(/"/g, '').split(',').map(num => Number(num.trim())).filter(Boolean);
        }

        form.setFieldsValue({
            firstName: driver.firstName || "",
            lastName: driver.lastName || "",
            userName: driver.userName || "",
            email: driver.email || "",
            dob: driver.dob ? dayjs(driver.dob, "YYYY-MM-DD") : null,
            phone: driver.phone || "",
            vehicle_number: driver.vehicle_number || "",
            vehicleType: driver.vehicleType || "",
            address: driver.address || "",
            city: driver.city || "",
            state: driver.state || "",
            zip_code: driver.zip_code || "",
            warehouse: warehouseIds
        });
    }, [driver]);

    const onClose = () => {
        setAddModalOpen(false);
        form.resetFields();
    };

    const handleEditSubmit = async () => {
        const values = await form.validateFields();
        console.log("Form Data:", values);
        delete values.password;
        try {
            const response = await ApiServices("put", ApiConfig.DRIVER + "/" + driver?.id, values);
            console.log(response, "== update drivers ==");
            onClose();
            getUsers()
            message.success("Driver Registered Successfully!");
        } catch (error) {
            console.log(error)
        }
    }

    const handleSubmit = async () => {
        console.log(userDetail.storeId, "id");

        try {
            const values = await form.validateFields();
            values.store_id = userDetail.storeId
            console.log("Form Data:", values);
            const response = await ApiServices("post", ApiConfig.ADD_DRIVER, values);
            if (response.status !== 200) {
                return message.error(response.message || "Failed to register driver.");
            }
            const driverId = response.data.id;
            const uploads = {
                photo: photoList[0]?.originFileObj,
                identityDocuments: identityDocuments[0]?.originFileObj,
                drivingLicense: drivingLicenseList[0]?.originFileObj,
            };
            // Upload documents concurrently
            const uploadResults = await Promise.all(
                Object.entries(uploads).map(async ([key, file]) => {
                    if (!file) return null;
                    const res = await uploadDocument(file, key);
                    return res?.data?.data?.id || null;
                })
            );
            // Update driver with uploaded document IDs
            await ApiServices("put", `${ApiConfig.DRIVER}/${driverId}`, {
                photo: uploadResults[0],
                identityDocuments: uploadResults[1],
                documents: uploadResults[2],

            });
            onClose();
            getUsers()
            message.success("Driver Registered Successfully!");
        } catch (error) {
            console.error("Error:", error);
            message.error(error.message || "Please fill all required fields correctly.");
        }
    };

    const handleChange = (value) => {
        console.log("Selected Warehouse Object:", value);
        // const selected = wareHouseData.find((wh) =>
        //     value.some((res) => res === wh.id)
        // );
        // setSelectedWarehouse([...selectedWarehouse, selected]);
    };

    return (
        <Drawer
            title={`${"Create a new Driver Account"}`}
            width={720}
            onClose={onClose}
            open={addModalOpen}
            styles={{ body: { paddingBottom: 80 } }}
            extra={
                <Space>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="primary" onClick={() => {
                        if (Object.keys(driver).length == 0) {
                            handleSubmit()
                        } else {
                            handleEditSubmit()
                        }
                    }}>
                        Submit
                    </Button>
                </Space>
            }
        >
            <Form
                form={form}
                layout="vertical"

            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="firstName"
                            label="First Name"
                            rules={[{ required: true, message: "Please enter First Name" }]}
                        >
                            <Input placeholder="First Name" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="lastName"
                            label="Last Name"
                            rules={[{ required: true, message: "Please enter Last Name" }]}
                        >
                            <Input placeholder="Last Name" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="userName"
                            label="User Name (Only Alphabets and Numbers)"
                            rules={[{ required: true, message: "Please enter User Name" }]}
                        >
                            <Input placeholder="User Name" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Gmail"
                            name="email"
                            rules={[
                                { required: true, message: "Please enter your Gmail!" },
                                {
                                    pattern: /^[a-zA-Z0-9._%+-]+@gmail\.com$/,
                                    message: "Please enter a valid Gmail (e.g., example@gmail.com)",
                                },
                            ]}
                        >
                            <Input placeholder="Enter your Gmail" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            name="password"
                            label="Password"
                            rules={[{ required: driver.password ? false : true, message: "Please enter Password" }]}
                        >
                            <Input.Password placeholder="Password" disabled={!driver.password ? false : true} />
                        </Form.Item>
                    </Col>

                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Date of Birth"
                            name="dob"
                            rules={[
                                { required: true, message: "Please select your Date of Birth!" },
                                {
                                    validator: (_, value) =>
                                        value && dayjs().diff(value, "years") >= 18
                                            ? Promise.resolve()
                                            : Promise.reject(new Error("You must be at least 18 years old!")),
                                },
                            ]}
                        >
                            <DatePicker format="YYYY-MM-DD" placeholder="Select DOB" style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="phone"
                            label="Phone"
                            rules={[{ required: true, message: "Please enter a valid phone number!" }]}
                        >
                            <PhoneInput country={"in"} inputStyle={{ width: "100%" }} enableSearch />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="vehicle_number"
                            label="Vehicle Number"
                            rules={[{ required: true, message: "Please enter Vehicle Number" }]}
                        >
                            <Input placeholder="Vehicle Number" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="vehicleType"
                            label="Vehicle Type (Ex. Car, Bike, Truck, etc.)"
                            rules={[{ required: true, message: "Please enter Vehicle Type" }]}
                        >
                            <Input placeholder="Vehicle Type" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="address"
                            label="Address"
                            rules={[{ required: true, message: 'Please enter Address' }]}
                        >
                            <Input placeholder="Address" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="city"
                            label="City"
                            rules={[{ required: true, message: 'Please enter City' }]}
                        >
                            <Input placeholder="City" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="state"
                            label="State"
                            rules={[{ required: true, message: 'Please enter State' }]}
                        >
                            <Input placeholder="State" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="zip_code"
                            label="Zip Code"
                            rules={[{ required: true, message: 'Please enter Zip Code' }]}
                        >
                            <Input placeholder="Zip Code" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="warehouse"
                            label="Select Warehouse"
                            rules={[{ required: true, message: "Please select a warehouse!" }]}
                        >
                            <Select
                                mode="multiple"
                                placeholder="Select Warehouse"
                                style={{ width: "100%" }}
                                onChange={handleChange}
                            >
                                {wareHouseData.map((wh) => (
                                    <Option key={wh.id} value={wh.id}>
                                        {wh.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>


                    {
                        Object.keys(driver).length == 0 &&

                        <>
                            <Col span={12}>
                                <Form.Item label="Upload Photo" name="photo" rules={[{ required: true, message: "Please upload a photo!" }]}>
                                    <Upload
                                        listType="text"
                                        beforeUpload={() => false}
                                        fileList={photoList}
                                        getValueFromEvent={(e) => e?.fileList}
                                        onChange={async ({ fileList }) => {
                                            setPhotoList(keepLocalFiles(fileList))
                                        }}
                                        maxCount={1}
                                    >
                                        <Button icon={<UploadOutlined />}>Upload</Button>
                                    </Upload>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Upload Driving License" name="documents" rules={[{ required: true, message: "Please upload at least one document!" }]}>
                                    <Upload
                                        listType="text"
                                        beforeUpload={() => false}
                                        fileList={drivingLicenseList}
                                        onChange={({ fileList }) => setDrivingLicenseList(keepLocalFiles(fileList))}
                                        multiple
                                    >
                                        <Button icon={<UploadOutlined />}>Upload</Button>
                                    </Upload>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Identity Documents" name="identityDocuments" rules={[{ required: true, message: "Please upload Identity Documents!" }]}>
                                    <Upload
                                        listType="text"
                                        beforeUpload={() => false}
                                        fileList={identityDocuments}
                                        onChange={({ fileList }) => setIdentityDocuments(keepLocalFiles(fileList))}
                                        maxCount={1}
                                    >
                                        <Button icon={<UploadOutlined />}>Upload</Button>
                                    </Upload>
                                </Form.Item>
                            </Col>
                        </>
                    }

                </Row>
            </Form>
        </Drawer >
    );
};

export default AddDrivers;
